var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-screen h-screen bg-black fixed top-0 left-0 z-30 opacity-20"})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }